/*                                      */

/**
 *
 *
 */
export const VERSION = '5.40.0';
export const PUBLIC_VERSION = '5';
